import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./form";
import CheckoutFormCharge from "./form-charge";

const stripePromise = loadStripe(
  "pk_test_51MxiEuCz0IOuD82c2C8H3dAlu6iMiHSyWYWxrtCzqvCjZdl5lNjX3ekMD5ZBZGcQJLgBJbCSjwHl8gmMmR1y1a3r00GXW6PiCg"
);
export default function TestPage() {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm />
      {/* <CheckoutFormCharge /> */}
    </Elements>
  );
}
